import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledSkeleton } = Styles;

export const Skeleton = ({ width, height, ...otherProps }) => {
    const widthStandardized = typeof width === 'number' ? `${width}px` : width;
    const heightStandardized = typeof height === 'number' ? `${height}px` : height;

    return <StyledSkeleton width={widthStandardized} height={heightStandardized} {...otherProps} />;
};

Skeleton.propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    background: PropTypes.string,
    shineBackground: PropTypes.string,
    circle: PropTypes.bool,
    duration: PropTypes.number,
};

Skeleton.defaultProps = {
    width: 300,
    height: 14,
    background: undefined,
    shineBackground: undefined,
    circle: false,
    duration: 1,
};

Skeleton.Styles = Styles;
